import { Injectable } from '@angular/core';
import { CanActivate, Router, ActivatedRouteSnapshot, RouterStateSnapshot, UrlTree } from '@angular/router';
import { AuthService } from './auth.service';  // Ajuste o caminho conforme seu projeto

@Injectable({
  providedIn: 'root'
})
export class AuthGuard implements CanActivate {

  constructor(private router: Router, private authService: AuthService) {}

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean | UrlTree {
    const url = state.url;

    const isLoggedIn = this.authService.isLoggedIn();

    // Se a rota contém "/auth" e o usuário está logado, redireciona para /home
    if (url.includes('/auth') && isLoggedIn) {
      return this.router.parseUrl('/home');
    }

    // Se não está logado e não está acessando rota /auth, redireciona para /auth/login
    if (!isLoggedIn && !url.includes('/auth')) {
      return this.router.parseUrl('/auth/login');
    }

    // Permite navegar normalmente
    return true;
  }
}
